import { Outlet } from 'react-router-dom';

export default function DashboardsLayout() {
  return <Outlet />;
}
